import { ArrowIcon } from "assets/icons";
import cn from "classnames";
import { useBoolean } from "hooks";
import { t } from "i18next";
import { Icon } from "ui";

import { DropdownWithStatisticProps } from "./DropdownWithStatistic.types";

import styles from "./DropdownWithStatistic.module.scss";

const DropdownWithStatistic = ({
  label,
  children,
  defaultOpen = false
}: DropdownWithStatisticProps) => {
  const { value: isOpen, toggle: toggleOpen } = useBoolean(defaultOpen);

  return (
    <div className={styles.dropdown}>
      <div className={styles.dropdown_header} onClick={toggleOpen}>
        <h3>{t(label)}</h3>
        <Icon
          as={ArrowIcon}
          boxSize={24}
          className={cn(styles.dropdown_arrow, {
            [styles.dropdown_arrow__open]: isOpen
          })}
        />
      </div>

      {isOpen && children}
    </div>
  );
};

export default DropdownWithStatistic;
